<template>
  <div v-if="products" class="rv__inner">
    <div ref="productSlider" class="rv__products-wrapper swiper-container">
      <div class="rv__products">
        <div v-for="(product, index) in products" :key="product.id + '_'+ index +'_' + refreshKey" class="rv__product">
          <ProductCard type="TypeA" :product="product" :showWishlistIcon="false" />
        </div>
      </div>
      <div class="rv__nav rv__prev">
        <svg class="rv__prev-icon">
          <use xlink:href="#icon-prev"></use>
        </svg>
      </div>
      <div class="rv__nav rv__next">
        <svg class="rv__next-icon">
          <use xlink:href="#icon-next"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup="props">
  import { computed, toRefs, ref, onMounted } from 'vue';
  import ProductCard from '../global/product-card/index.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';

  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    products: {
      type: Object,
      required: true,
    },
    sourceEop: {
      type: String,
      required: false,
    }
  });

  const { data, sourceEop } = toRefs(props);
  const refreshKey = ref(0);

  onMounted(() => {
    new Swiper(productSlider.value, productCarousel.value);

    // Render reviews when user reaches to that view
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof window.refreshYotpoData === 'function') {
            window.refreshYotpoData();
            refreshKey.value = refreshKey.value + 1; // Refreshing the product card component to adjust the swatches
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.1,
    });

    if (productSlider.value) {
      observer.observe(productSlider.value);
    }
  });

  var productSlider = ref(null);

  const productCarousel = computed(() => {
    return {
      slidesPerView: 1.6,
      spaceBetween: sourceEop.value ? 24 : 16,
      wrapperClass: 'rv__products',
      slideClass: 'rv__product',
      threshold: 6, // will get swiped only when drag is atleast 6px
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: sourceEop.value ? 2.6 : 2.8,
          spaceBetween: sourceEop.value ? 24 : 16,
        },
        1024: {
          slidesPerView: sourceEop.value ? 4 : 3,
          spaceBetween: sourceEop.value ? 24 : 32,
        },
        1367: {
          slidesPerView: 4,
          spaceBetween: sourceEop.value ? 24 : 32,
        },
      },
      navigation: {
        nextEl: '.rv__next',
        prevEl: '.rv__prev',
      },
      a11y: {
        enabled: true,
      },
    };
  });
</script>
